import { useState } from "react";

export function useCan(user) {
  const editable = ["superadmin", "admin", "calidad"].includes(user?.rol);
  return editable;
}

export function PageHeader({ overline, title, action, help }) {
  return (
    <div className="mb-6 sm:mb-8 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3">
      <div className="min-w-0">
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#FF5625] mb-1">{overline}</div>
        <h1 className="text-2xl sm:text-3xl font-black tracking-tighter text-[#0E2A47] break-words flex items-center gap-2">
          {title}
          {help && (
            <a href={`/ayuda#${help}`} title="¿Cómo funciona?" data-testid={`help-${help}`}
              className="inline-flex items-center justify-center h-5 w-5 rounded-full bg-[#0E2A47]/10 text-[#0E2A47]/60 hover:bg-[#FF5625] hover:text-white text-xs font-bold transition-colors shrink-0">?</a>
          )}
        </h1>
      </div>
      {action && <div className="flex flex-wrap items-center gap-2 shrink-0">{action}</div>}
    </div>
  );
}

export function useScopeGuard(user, scopeTenant) {
  return user?.rol === "superadmin" && !scopeTenant;
}

export function ScopeNotice() {
  return (
    <div className="text-[#0E2A47]/60" data-testid="scope-notice">
      Seleccione un tenant en la sección <b>Tenants</b> para continuar.
    </div>
  );
}

export function useForceRender() {
  const [, set] = useState(0);
  return () => set((n) => n + 1);
}

export function fmtNum(v) {
  if (v === null || v === undefined || v === "") return v;
  const n = Number(v);
  if (Number.isNaN(n)) return v;
  return Number(n.toFixed(3)).toString();
}
